import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../layouts/shared-service';
import { environment } from 'environments/environment.prod';
import { MdDialog, MdDialogRef, MdDialogConfig } from '@angular/material';
@Component({
  selector: 'page-layouts',
  templateUrl: './home.html',
  styleUrls: ['./home.scss']
})

export class homepage implements OnInit {
  pageTitle: string = environment.sysName;
  version:string = environment.sysVersion;
  constructor( public dialog: MdDialog,private _sharedService: SharedService ) {
    this._sharedService.emitChange(this.pageTitle);
    this.dialog.closeAll();
  }


  ngOnInit() {}

}



// WEBPACK FOOTER //
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/pages/home/home.ts